import defaultLocales from 'globals/locales/default';

export const headLabelsLongVersion = [
  defaultLocales.teammate,
  defaultLocales.lastActivity,
  defaultLocales.invitations,
  defaultLocales.reports,
  '',
];
export const dummyPagination = {
  itemsPerPage: 10,
  currentPage: 1,
  numberOfPages: 100,
};
